<span class="material-icons reponsive-menu" (click)="closeMenu()">close</span>
<div class="menu-overlay">
  <div class="h-full p-2 border-r relative">

    <div class="space-y-6">

      <div class="space-y-2">
        <div class="h-2 bg-gray-200 rounded-full">
          <div class="h-full bg-blue-500 rounded-full progress" [ngStyle]="{ width: progressWidth }"></div>
        </div>
        <div class="text-sm text-gray-600">{{ answeredQuestionCount }}/{{ questions.length }} Answered</div>
      </div>

      <div class="space-y-2">
        <h3 class="font-semibold">Question Status</h3>
        <div class="grid grid-cols-5 gap-2">
          <button *ngFor="let question of questions; let i = index" (click)="jumpToQuestion(i)"
            [class]="'p-2 rounded-lg text-sm font-medium question-badge ' + getStatusColor(questionStatus[i])">
            {{ i + 1 }}
          </button>
        </div>
      </div>

      <div class="space-y-2">
        <div class="space-y-1 text-sm">
          <div class="flex items-center space-x-2">
            <div class="w-4 h-4 rounded bg-gray-200"></div>
            <span>Not Visited</span>
          </div>
          <div class="flex items-center space-x-2">
            <div class="w-4 h-4 rounded bg-blue-500"></div>
            <span>Current</span>
          </div>
          <div class="flex items-center space-x-2">
            <div class="w-4 h-4 rounded bg-green-500"></div>
            <span>Answered</span>
          </div>
          <div class="flex items-center space-x-2">
            <div class="w-4 h-4 rounded bg-yellow-500"></div>
            <span>Skipped</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>